import { render, staticRenderFns } from "./SourceModal.vue?vue&type=template&id=4683d8a2&scoped=true"
import script from "./SourceModal.vue?vue&type=script&lang=js"
export * from "./SourceModal.vue?vue&type=script&lang=js"
import style0 from "./SourceModal.vue?vue&type=style&index=0&id=4683d8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683d8a2",
  null
  
)

export default component.exports